import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { ClearTextIcon } from '@omilia/icon';
import { MessageStatus } from 'types';
import { getThemeProp } from 'styles/theme';

const fileStatusBackgroundColor = {
  [MessageStatus.PENDING]: colors.COLOR_GREY_400,
  [MessageStatus.SENT]: getThemeProp('primaryColor'),
  [MessageStatus.ERROR]: colors.COLOR_RED_400,
};

const fileUtteranceStatusColor = {
  [MessageStatus.PENDING]: colors.COLOR_BLACK,
  [MessageStatus.SENT]: colors.COLOR_WHITE,
  [MessageStatus.ERROR]: colors.COLOR_RED_900,
};

export const SFilePreview = styled.div<{
  asMessage: boolean;
  isError: boolean;
}>`
  align-items: ${({ asMessage }) => (asMessage ? 'start' : 'center')};
  background-color: ${colors.COLOR_WHITE};
  border-radius: ${({ asMessage }) => (asMessage ? '10px' : '24px')};
  box-shadow: ${({ asMessage, isError }) =>
    asMessage || isError ? 'none' : '0px 1px 3px -1px rgba(16, 24, 40, 0.6)'};
  box-sizing: border-box;
  display: flex;
  flex-direction: ${({ asMessage }) => (asMessage ? 'column' : 'row')};
  padding: ${({ asMessage }) => (asMessage ? '12px 16px' : '18px 16px')};
  width: 100%;
`;
export const SFileContent = styled.div<{ isError: boolean }>`
  align-items: center;
  display: flex;

  span {
    color: ${({ isError }) =>
      isError ? colors.COLOR_RED_800 : colors.COLOR_GREY_900};
  }
`;
export const SFileName = styled.span<{ asMessage?: boolean; width: number }>`
  font-weight: ${({ asMessage }) => (asMessage ? 'normal' : 'bold')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${({ width }) => `${width}px` || '180px'};
  max-width: 180px;
`;
export const SFileSize = styled.span<{
  asMessage?: boolean;
  isError: boolean;
}>`
  color: ${({ isError }) =>
    isError ? colors.COLOR_RED_800 : colors.COLOR_GREY_900};
  display: inline-block;
  font-size: ${({ asMessage }) => (asMessage ? '12px' : '14px')};
  margin: ${({ asMessage }) => (asMessage ? '8px 0 0 0' : '0 0 0 4px')};
`;

export const SFileIcon = styled.div`
  margin-right: 8px;
  min-width: 22px;
`;
export const SCloseIcon = styled(ClearTextIcon)`
  cursor: pointer;
  margin-left: auto;
  min-width: 18px;
`;

export const SBackground = styled.div<{
  status: MessageStatus;
  asMessage: boolean;
  isError: boolean;
}>`
  background-color: ${({ asMessage, status, isError }) => {
    if (asMessage) {
      return fileStatusBackgroundColor[status];
    }

    return isError ? colors.COLOR_RED_400 : colors.COLOR_GREY_400;
  }};
  border-radius: ${({ asMessage }) => (asMessage ? '12px' : '27px')};
  box-sizing: border-box;
  margin: ${({ asMessage, isError }) => {
    if (asMessage) {
      return '0';
    } else if (isError) {
      return '12px 0 0 0';
    }
    return '8px 0 8px 0';
  }};
  padding: ${({ asMessage, isError }) => (asMessage || isError ? '2px' : '0')};
  width: 100%;
`;

export const SPreviewContainer = styled.div<{ asMessage: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ asMessage }) => (asMessage ? '6px' : '0px')};
  max-width: ${({ asMessage }) => (asMessage ? '240px' : 'none')};
  width: 100%;
`;

export const SErrorMessage = styled.span<{ asMessage?: boolean }>`
  align-self: end;
  color: ${colors.COLOR_ALERT_ERROR};
  font-size: 11px;
  margin-bottom: ${({ asMessage }) => (asMessage ? '16px' : '0px')};
`;

export const SFileStatus = styled.div<{ withStatus: boolean }>`
  display: flex;
  justify-content: end;
  margin-top: ${({ withStatus }) => (withStatus ? '8px' : '2px')};
`;

export const SStatusMessage = styled.span`
  color: ${colors.COLOR_GREY_900};
  display: flex;
  font-size: 12px;

  i::after {
    height: 10px;
    margin-left: 8px;
    width: 10px;
  }
`;

export const SFileUtterance = styled.span<{ status: MessageStatus }>`
  color: ${({ status }) => fileUtteranceStatusColor[status]};
  display: block;
  font-size: 14px;
  margin: 8px 15px 8px;
  word-break: break-word;
`;
